
import { defineComponent, toRefs, computed } from 'vue'

export default defineComponent({
    name: 'Services',
    props: {
        text: String,
    },
    setup(props) {
        const { text } = toRefs(props)

        const quoteImage = computed(() => {
            return require('@/assets/images/bjorn-bylund-quote-image.png')
        })

        const quoteSignStart = computed(() => {
            return require('@/assets/icons/quote-start.svg')
        })

        const quoteSignEnd = computed(() => {
            return require('@/assets/icons/quote-end.svg')
        })

        const quote = computed(() => {
            return text
        })

        return {
            quote,
            quoteImage,
            quoteSignStart,
            quoteSignEnd,
        }
    },
})
